import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useFilterAndSearchStore } from 'pages/howTo/store/filterAndSearch'
import { type ISectionWithCategoryIdItem } from 'pages/howTo/types/interfaces/IHowTo'
import colors from 'styles/colors'

export const FilterSections = ({
    filters
}: {
    filters: ISectionWithCategoryIdItem[] | undefined
}) => {
    const { t } = useTranslation()

    const filterId = useFilterAndSearchStore(state => state.filterId)
    const changeFilter = useFilterAndSearchStore(state => state.changeFilter)
    const setSearchTerm = useFilterAndSearchStore(state => state.setSearchTerm)

    return (
        <StyledFilterWrapper>
            <StyledFilterTab
                key='All'
                $isActive={filterId === null}
                onClick={() => {
                    changeFilter(null)
                    setSearchTerm({ query: '', category: '' })
                }}
            >
                {t('All')}
            </StyledFilterTab>
            {filters?.map(filter => (
                <StyledFilterTab
                    key={filter.id}
                    $isActive={filter.id === filterId}
                    onClick={() => {
                        changeFilter(filter.id)
                        setSearchTerm({ query: '', category: '' })
                    }}
                >
                    {t(filter.name)}
                </StyledFilterTab>
            ))}
        </StyledFilterWrapper>
    )
}

const StyledFilterWrapper = styled.div`
    color: ${colors.blueDark};
    display: flex;
    height: 5rem;
    margin-bottom: 1rem;
    overflow-x: auto;
`

interface FilterTabProps {
    $isActive: boolean
}

const StyledFilterTab = styled.button<FilterTabProps>`
    align-items: center;
    border: 0.1rem solid #c1c1c1;
    border-radius: 16rem;
    color: ${colors.grey};
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin-right: 1rem;
    height: 3.5rem;
    padding: 0 2rem;
    text-transform: capitalize;
    ${props =>
        props.$isActive &&
        `
            border: 0.1rem solid transparent;
            background: ${colors.blue92deg};
            color: ${colors.white};
        `}
`
